import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { SnackbarService } from 'src/app/shared/services/snackBarService.service';
import { Utils } from 'src/app/shared/utils/utils';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private _snackbar: SnackbarService, private _zone: NgZone) {}

  handleError(error: unknown): void {
    console.error('[GlobalErrorHandler]', error);

    if (Utils.isHttpLayerError(error)) {
      return;
    }

    const message = Utils.getUserFacingErrorMessage(error);
    if (!message) {
      return;
    }

    this._zone.run(() => {
      this._snackbar.open(message, 'Dismiss', 'error');
    });
  }
}
